(() => {
  const form = document.querySelector("form#custom_registration");
  if (!form) return;

  const formMessages = JSON.parse(
    form.querySelector("[data-form-messages]").innerText
  );

  const addSocialMedia = form.querySelector("button.add-social-media");
  addSocialMedia.addEventListener("click", () => {
    socialMediaInputs = form.querySelectorAll('input[name="social"]');
    const newInput = document.createElement("input");
    newInput.setAttribute("type", "url");
    newInput.setAttribute("name", "social");
    addSocialMedia.parentElement.insertBefore(newInput, addSocialMedia);
    newInput.focus();
  });

  const countryInput = form.querySelector('select[name="country_code"]');
  const countryInputOptions = Array.from(
    countryInput.querySelectorAll("option")
  );
  const provinceInputWrapper = form.querySelector(".province-input-wrapper");

  countryInput.addEventListener("change", (e) => {
    setTimeout(() => {
      const selectedOption = countryInputOptions.find(
        (option) => option.value === countryInput.value
      );

      const provinces = JSON.parse(
        selectedOption?.getAttribute("data-provinces") || "[]"
      );

      const currentProvinceInput =
        provinceInputWrapper.querySelector(".select-wrapper");
      if (currentProvinceInput) {
        provinceInputWrapper.removeChild(currentProvinceInput);
      }
      provinceInputWrapper.style.display = "none";

      if (provinces?.length) {
        const provinceInput = document.createElement("select");
        provinceInput.setAttribute("id", "URF-province");
        provinceInput.setAttribute("name", "province_code");
        provinceInput.setAttribute("required", "required");
        const emptyOption = document.createElement("option");
        emptyOption.setAttribute("disabled", "disabled");
        emptyOption.setAttribute("selected", "selected");
        provinceInput.appendChild(emptyOption);
        provinces.forEach((province) => {
          const provinceOption = document.createElement("option");
          provinceOption.value = province[0];
          provinceOption.innerText = province[1];
          provinceInput.appendChild(provinceOption);
        });
        provinceInput.addEventListener("change", () => {
          setTimeout(() => {
            validateField(provinceInput);
            handleFieldUpdate();

            const surchargeTaxInputWrapper = form.querySelector(
              ".surcharge-tax-input-wrapper"
            );
            if (surchargeTaxInputWrapper) {
              const surchargeTaxInput =
                surchargeTaxInputWrapper.querySelector("select");
              clearSelectField(surchargeTaxInput);
              if (
                ![
                  "ceuta",
                  "las palmas",
                  "melilla",
                  "santa cruz de tenerife",
                ].includes(provinceInput.value.toLowerCase()) &&
                countryInput.value === "ES"
              ) {
                surchargeTaxInput.removeAttribute("disabled");
                surchargeTaxInputWrapper.style.display = "block";
              } else {
                surchargeTaxInput.setAttribute("disabled", "disabled");
                surchargeTaxInputWrapper.style.display = "none";
              }
            }
          }, 0);
        });
        provinceInputWrapper.style.display = "block";
        provinceInputWrapper.appendChild(provinceInput);
        window.dispatchEvent(semanticSelectEvt);
      }

      const surchargeTaxInputWrapper = form.querySelector(
        ".surcharge-tax-input-wrapper"
      );
      if (surchargeTaxInputWrapper) {
        const surchargeTaxInput =
          surchargeTaxInputWrapper.querySelector("select");
        clearSelectField(surchargeTaxInput);
        if (countryInput.value === "ES") {
          surchargeTaxInput.removeAttribute("disabled");
          surchargeTaxInputWrapper.style.display = "block";
        } else {
          surchargeTaxInput.setAttribute("disabled", "disabled");
          surchargeTaxInputWrapper.style.display = "none";
        }
      }

      const taxIdPrefixInput = form.querySelector(
        'input[name="tax_id_prefix"]'
      );
      if (taxIdPrefixInput) {
        taxIdPrefixInput.setAttribute("value", countryInput.value);
      }
    }, 0);
  });

  Array.from(form.querySelectorAll("input, select")).forEach((field) => {
    if (field.tagName === "INPUT") {
      field.addEventListener("blur", () => {
        validateField(field);
      });
    }
    field.addEventListener("change", () => {
      if (field.tagName === "SELECT") {
        setTimeout(() => {
          validateField(field);
        }, 0);
      }
      handleFieldUpdate();
    });
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  const submitButton = form.querySelector('button[type="submit"]');
  submitButton.addEventListener("click", async (e) => {
    e.preventDefault();
    e.stopPropagation();

    form.classList.add("--submitting");

    const formData = new FormData(form);

    const res = await fetch(
      "https://yesitex-app-t2y8i.ondigitalocean.app/api/register-form/submit",
      {
        method: "POST",
        body: formData,
      }
    );

    form.classList.remove("--submitting");

    const formMessage = form.querySelector(".form-message");

    if (res.status === 200) {
      formMessage.classList.remove("--error");
      formMessage.innerText = formMessages.success_text;
      resetForm(form);
      return;
    }

    const data = await res.json();

    if (data.validationErrors?.length) {
      data.validationErrors.forEach((v_error) => {
        const field = form.querySelector(`[name="${v_error.field}"]`);
        renderError(field, v_error.message);
      });
    }

    if (data.error) {
      formMessage.classList.add("--error");
      formMessage.innerText = data.error;
      submitButton.setAttribute("disabled", "disabled");
    }
  });

  function handleFieldUpdate() {
    const requiredFields = Array.from(form.querySelectorAll("[required]"));
    if (
      requiredFields.some((field) => {
        const wrapper = field.closest(".input");
        let empty = !!wrapper?.classList.contains("has-error");
        if (
          field.tagName === "SELECT" &&
          (!field.value || field.value === "---")
        ) {
          empty = true;
        }
        if (field.tagName === "INPUT") {
          if (
            (field.getAttribute("type") === "checkbox" && !field.checked) ||
            (field.getAttribute("type") !== "checkbox" && !field.value)
          ) {
            empty = true;
          }
        }

        return empty;
      })
    ) {
      submitButton.setAttribute("disabled", "disabled");
    } else {
      submitButton.removeAttribute("disabled");
    }
  }

  function validateField(field) {
    if (field.classList.contains("skip-validation")) {
      field.classList.remove("skip-validation");
      return;
    }
    const required = field.hasAttribute("required");
    if (field.tagName === "INPUT") {
      const type = field.getAttribute("type");

      if (
        required &&
        ((type === "checkbox" && !field.checked) ||
          (type !== "checkbox" && !field.value))
      ) {
        renderError(field, formMessages.required_field_error);
      } else if (
        field.value &&
        type === "email" &&
        !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(field.value)
      ) {
        renderError(field, formMessages.email_validation_error);
      } else if (
        field.value &&
        type === "url" &&
        !/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(
          field.value
        )
      ) {
        renderError(field, formMessages.url_validation_error);
      } else if (
        field.getAttribute("id") === "URF-tax-id" &&
        field.value?.slice(0, 2) ===
          form.querySelector("input#URF-tax-id-prefix")?.value
      ) {
        renderError(field, formMessages.double_vat_prefix_error);
      } else {
        renderError(field);
      }
    } else if (field.tagName === "SELECT") {
      if (required && (!field.value || field.value === "---")) {
        renderError(field, formMessages.required_field_error);
      } else {
        renderError(field);
      }
    }
  }

  function renderError(field, message) {
    const wrapper =
      field.closest(".input") ||
      field.closest(".input-with-button") ||
      field.closest(".input-with-prefix");
    let errorBox = wrapper.querySelector(".error-box");
    if (!errorBox) {
      errorBox = document.createElement("p");
      errorBox.classList.add("error-box");
      wrapper.appendChild(errorBox);
    }
    if (message) {
      errorBox.innerText = message;
      wrapper.classList.add("has-error");
      submitButton.setAttribute("disabled", "disabled");
    } else {
      errorBox.innerText = "";
      wrapper.classList.remove("has-error");
    }
  }

  function clearSelectField(field) {
    field.value = "";
    field.classList.add("skip-validation");
    const replacement = field.parentElement.querySelector(".bv_mainselect");
    if (replacement) {
      const activeValue = replacement.querySelector(".sl_inner");
      if (activeValue) activeValue.innerText = "";
      replacement.querySelectorAll("li").forEach((li) => {
        li.classList.remove("active");
      });
    }
    field.dispatchEvent(new Event("change"));
  }

  function resetForm(form) {
    form.querySelectorAll("input").forEach((input) => {
      if (["locale", "shop"].includes(input.getAttribute("name"))) {
        return;
      }
      if (input.getAttribute("type") === "checkbox") {
        input.checked = false;
      } else {
        input.value = "";
      }
    });

    form.querySelectorAll("select").forEach((select) => {
      clearSelectField(select);
    });
  }
})();
